// extracted by mini-css-extract-plugin
export default {"block__one":"thisDay_block__one__605Ga","block__one__inner":"thisDay_block__one__inner__PySUw","block__one__inner__svg":"thisDay_block__one__inner__svg__LNUcO"};